import { useEffect } from 'react';
import { FormikProps, useFormik } from 'formik';
import * as Yup from 'yup';

import { useZoneRatingMutation } from 'store/apis';

interface UseZoneRatingFormManagerProps {
  zoneId: number;
  next?: (data?: any) => void;
}

export const useZoneRatingFormManager = ({ zoneId, next = () => {} }: UseZoneRatingFormManagerProps) => {
  const [mutate, { isLoading, isSuccess, isError, ...rest }] = useZoneRatingMutation();

  const initialValues = {
    rating: null,
  };

  const validationSchema = Yup.object({
    rating: Yup.number().required('This value is required.'),
  });

  const formManager = useFormik({
    initialValues,
    validationSchema,
    onSubmit: (zoneRating) => {
      if (zoneRating.rating) {
        mutate({
          zoneId,
          rating: zoneRating.rating,
        });
      }
    },
  });

  useEffect(() => {
    if (!isLoading && isSuccess && !isError) {
      const { data } = rest;

      next(data);
    }
  }, [isLoading, isSuccess, isError]);

  return [
    {
      formManager,
      loading: isLoading,
    },
  ] as [
    {
      formManager: FormikProps<typeof initialValues>;
      loading: boolean;
    },
  ];
};
